import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DashboardRoutingModule} from './dashboard-routing.module';
import {DashboadDefaultComponent} from './dashboad-default/dashboad-default.component';
import {NgxEchartsModule} from 'ngx-echarts';
import {SharedComponentsModule} from 'src/app/shared/components/shared-components.module';
import {DashboardV2Component} from './dashboard-v2/dashboard-v2.component';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {DashboardV3Component} from './dashboard-v3/dashboard-v3.component';
import {DashboardV4Component} from './dashboard-v4/dashboard-v4.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/dashboard/', '.json');
}

@NgModule({
    imports: [
        CommonModule,
        SharedComponentsModule,
        NgxEchartsModule,
        NgxDatatableModule,
        NgbModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        DashboardRoutingModule
    ],
    declarations: [DashboadDefaultComponent, DashboardV2Component, DashboardV3Component, DashboardV4Component]
})
export class DashboardModule {
}
